<template lang="pug">
  v-row(align="center" justify="center")
    v-col.mt-4(cols="8")
      v-card
        v-card-title
          | Features Product
          v-spacer
          v-text-field.mt-n5(v-model='search' append-icon='mdi-magnify' label='Search' single-line hide-details fixed-header @keyup.enter="fetchFeatures()")
          v-spacer
          v-tooltip(bottom)
            template(v-slot:activator="{ on }")
              v-btn(icon)
                v-icon(@click="dialog = true" v-on="on") mdi-tag-text-outline
            span Add Features
        v-data-table(:headers="headers" :items="features" :options.sync="options" :server-items-length="totalFeatures" disable-sort)
          template(v-slot:item.icon='{ item }')
            v-icon {{ item.icon }}
          template(v-slot:item.action='{ item }')
            v-btn(icon)
              v-icon(small @click="editItem(item)") mdi-pencil
            v-btn(icon)
              v-icon(small @click="deleteItem(item.id)") mdi-delete
        v-dialog(v-model='dialog' persistent max-width='600px')
          v-card
            v-card-title
              span.headline Add Features
            v-card-text
              v-container
                v-row
                  v-col(cols="12")
                    v-text-field(v-model="featureIcon" label="Icon Name ( mdi-icon )" hide-details)
                  template(v-for="locale in locales")
                    v-col(cols="12")
                      v-text-field(v-model="locale.text" :label="getLang(locale.name) + ' Text'" hide-details)
            v-card-actions
              v-spacer
              v-btn(color="red darken-3" text @click="closeDialog") Close
              v-btn(color="success" text @click='saveFeature') Save
</template>

<script>
import ISO6391 from 'iso-639-1'

export default {
  name: 'FeatureProduct',
  data: () => ({
    search: '',
    dialog: false,
    features: [],
    headers: [
      { text: 'Features', value: 'name' },
      { text: 'Icon', value: 'icon', width: '30%'  },
      { text: 'Action', value: 'action', sortable: false, width: '20%' }
    ],
    locales: [],
    featureID: null,
    featureIcon: '',
    options: {
      itemsPerPage: 10
    },
    totalFeatures: 0
  }),
  watch: {
    options: {
      handler () {
        // console.log(this.options)
        this.fetchFeatures(this.options.page, this.options.itemsPerPage)
      },
      deep: true
    }
  },
  mounted () {
    this.fetchLocales()
    this.fetchFeatures()
  },
  methods: {
    fetchFeatures (page = 1, itemsPerPage = 10) {
      this.$axios.get(`/features/?ordering=name&type=product&page=${page}&page_size=${itemsPerPage}&search=${this.search}`)
        .then(resp => {
          this.features = [...resp.data.results]
          this.totalFeatures = resp.data.count
        })
    },
    fetchLocales () {
      this.axios.get('/locales/')
        .then(resp => {
          this.locales = [...resp.data.results]
        })
    },
    saveFeature () {
      let check = 0
      if (this.featureIcon && this.locales[0].text) {
        if (this.featureID) {
          this.$axios.patch(`/features/${this.featureID}/`, { name: this.locales[0].text, icon: 'mdi-' + this.featureIcon })
            .then(resp => {
              this.locales.forEach(f => {
                if (f.fid) {
                  this.$axios.patch(`/featurelocales/${f.fid}/`, { text: f.text })
                    .catch(err =>{
                      check + 1
                      console.log(err)
                    })
                  f.fid = null
                } else {
                  this.$axios.post('/featurelocales/', { text: f.text, feature: this.featureID, locale: f.id })
                    .catch(err =>{
                      check + 1
                      console.log(err)
                    })
                }
                f.text = ''
              })
            })
            .catch(err =>{
              check + 1
              console.log(err)
            })
          if (check > 0) {
            this.$alert.failed('Error Edit Feature')
          } else {
            this.$alert.success('Edit Feature Successful!')
            this.fetchFeatures()
          }
          this.dialog = false
        } else {
          this.$axios.post('/features/',{ type: 'product', name: this.locales[0].text, icon: 'mdi-' + this.featureIcon })
            .then(resp => {
              if (resp.data.id) {
                this.locales.forEach(f => {
                  this.$axios.post('/featurelocales/', {text: f.text, feature: resp.data.id, locale: f.id})
                    .catch(err =>{
                      check + 1
                      console.log(err)
                    })
                  f.text = ''
                })
                if (check > 0) {
                  this.$alert.failed('Error Add Feature')
                } else {
                  this.$alert.success('Add Feature Successful!')
                  this.fetchFeatures()
                }
                this.dialog = false
              }
              this.featureIcon = ''
            })
        }
      } else {
        this.$alert.failed('Please fill in all fields!')
      }
    },
    getLang (lg) {
      let newLg = ISO6391.getName(lg.substr(0,2))
      return newLg
    },
    editItem (item) {
        this.dialog = true
        this.featureID = item.id
        this.featureIcon = item.icon.substr(4)
        this.$axios.get(`/featurelocales/?feature=${item.id}`)
          .then(resp => {
            resp.data.results.forEach(r => {
              this.$set(this.locales.filter(e => e.id === r.locale)[0], 'text', r.text)
              this.$set(this.locales.filter(e => e.id === r.locale)[0], 'fid', r.id)
            })
          })
    },
    deleteItem (item) {
      // const index = this.desserts.indexOf(item)
      confirm('Are you sure you want to remove this feature?') &&
      this.$axios.delete(`/features/${item}/`)
       .then(resp => {
         this.$showAlert('grey darken-2','Remove Feature Successful!')
         this.fetchFeatures()
       })
    },
    closeDialog () {
      this.dialog = false
      this.featureID = null
      this.featureIcon = ''
      this.locales.forEach(l => { l.text = ''})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>